import { appElementsProvider } from "./appElements";
import { log } from "./log";

export const useTwind = () => {
    const { tw, tx } = appElementsProvider.getAppElements();

    if (!tw || !tx) {
        log.warn("Twind is not initialized. Returning empty functions.");
        // Return empty functions to avoid breaking the app
        return {
            tw: () => "",
            tx: () => "",
        };
    }
    return { tw, tx };
};
